import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/deliveries/bank-details`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Bank details saved successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/deliveries/bank-details`,
      method: "patch",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Bank details updated successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const get = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/deliveries/bank-details`,
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: false,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const setActive = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/deliveries/bank-details/set-active`,
      method: "patch",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Bank details set as active successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  create,
  update,
  get,
  setActive,
};
